module.exports = __webpack_public_path__ + "img/section1-1.6e88c4d7.jpg";